import classNames from 'classnames';
import { useContext } from 'react';
import { StoresContext } from '../../../../App';
import Picture from '../../../picture';
import EtmLogoWebp from '../images/partners/etm-logo.webp';
import EtmLogoPng from '../images/partners/etm-logo.png';
import RusSvetLogoWebp from '../images/partners/rus-svet-logo.webp';
import RusSvetLogoPng from '../images/partners/rus-svet-logo.png';

interface FederalNetworkCompany {
    name: string;
    type: 'search';
    features: FederalPartner[];
}

interface FederalPartner {
    id: string;
    name: string;
    value: string[];
    logoWebp: string;
    logoFallback: string;
}

const federalNetworkCompanies: FederalNetworkCompany[] = [
    {
        name: 'ДИСТРИБЬЮТОРЫ',
        type: 'search',
        features: [
            {
                id: 'etm',
                name: 'ЭТМ',
                value: ['этм'],
                logoWebp: EtmLogoWebp,
                logoFallback: EtmLogoPng,
            },
            {
                id: 'rus-svet',
                name: 'Русский свет',
                value: ['русский свет'],
                logoWebp: RusSvetLogoWebp,
                logoFallback: RusSvetLogoPng,
            },
        ],
    },
];

export default function FederalFilterSection() {
    const { featureSearch, setFeatureSearch, activeFilter, setActiveFilter } =
        useContext(StoresContext);

    const handleFederalSearch = (value: string[]) => {
        if (activeFilter === 'engineering') {
            setActiveFilter(null);
        }

        setFeatureSearch(value);
    };

    const arraysEqual = (itemA: string[], itemB: string[]) =>
        itemA.length === itemB.length &&
        itemA.every((item, index) => item.toLowerCase() === itemB[index].toLowerCase());

    return (
        <div className="distributor-offices-block">
            <h2 className="distributor-offices-block__title">ОФИСЫ ПРОДАЖ ДИСТРИБЬЮТОРОВ</h2>
            <div className="distributor-offices-block__grid">
                {federalNetworkCompanies[0].features.map((partner) => {
                    const isActive =
                        featureSearch.length > 0 && arraysEqual(featureSearch, partner.value);
                    return (
                        <button
                            key={partner.id}
                            type="button"
                            className={classNames(
                                'distributor-offices-block__card',
                                isActive && 'distributor-offices-block__card--active'
                            )}
                            onClick={() => handleFederalSearch(isActive ? [] : partner.value)}
                        >
                            <Picture
                                webp={partner.logoWebp}
                                fallback={partner.logoFallback}
                                alt={partner.name}
                                className="distributor-offices-block__card-logo"
                            />
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
